export default __webpack_public_path__ + "static/media/Frame 10950.3440eb56.svg";